import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const TestExecutionLoadable = Loadable({
  loading: LoadingPage,
  loader: () => import('./test-execution-page'),
});
